import { render, staticRenderFns } from "./SidebarServiceOrdersIndicator.vue?vue&type=template&id=caced6cc&scoped=true"
import script from "./SidebarServiceOrdersIndicator.vue?vue&type=script&lang=js"
export * from "./SidebarServiceOrdersIndicator.vue?vue&type=script&lang=js"
import style0 from "./SidebarServiceOrdersIndicator.vue?vue&type=style&index=0&id=caced6cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caced6cc",
  null
  
)

export default component.exports